module.exports = __webpack_public_path__ + "static/media/logoSimples.774a6905.svg";